<template>
  <div class="base_main">
    <img src="@/assets/page_bg.png" alt="" class="img_bg">
    <div class="base_div">
      <div class="div_left">
        <img src="@/assets/page_gut_const.png" alt="" class="img_l_1">
        <img src="@/assets/page_spac.png" alt="" class="img_l_2">
        <img src="@/assets/page_but.png" alt="" class="img_l_3">
        <div class="img_but_text">{{msg}}</div>
      </div>
      <div class="div_right">
        <img src="@/assets/page_text_bg.png" alt="" class="img_bg">
        <div class="base_slot">
          <slot></slot>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PageBasePc',
  props: {
    msg: String
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.img_bg {
  width: 100%;
}
.base_main {
  position: relative;
}
.base_div {
  position: absolute;
  top: 2rem;
  left: 6rem;
  right: 6rem;
}
.div_left {
  float: left;
  margin-left: 3rem;
}
.div_right {
  float: left;
  position: relative;
  width: 60%;
  margin-left: 3rem;
}
.img_l_1 {
  float: left;
  width: 0.8rem;
  margin-top: 2rem;
  margin-right: 10px;
}
.img_l_2 {
  float: left;
  width: 0.7rem;
}
.img_l_3 {
  width: 10rem;
  margin-top: 1.1rem;
}
.base_slot {
  position: absolute;
  padding: 1rem;
  top: 0;
}
.img_but_text {
  margin-top: -2.2rem;
  color: #fff;
  text-align: right;
  padding-right: 1.5rem;
}
</style>
